import { useTranslation } from 'react-i18next';
import TickerTape from './ui/TickerTape';

const LiquidityStats = () => {
  const { t } = useTranslation();

  const items = [
    { label: t('ticker.tvl'), value: '$45,120,480', accent: true },
    { label: t('ticker.stakers'), value: '12,400' },
    { label: t('ticker.paid'), value: '$8,240,000', accent: true },
    { label: t('ticker.apr'), value: '438.00%', accent: true },
    { label: t('ticker.minDeposit'), value: '5 USDT' },
    { label: t('ticker.chain'), value: 'BNB Chain' },
    { label: t('ticker.contract'), value: '0xab…c12' },
    { label: t('ticker.audit'), value: 'PASSED', accent: true },
    { label: t('ticker.upgrade'), value: 'NONE' },
    { label: t('ticker.custody'), value: 'NON-CUSTODIAL' },
  ];

  return <TickerTape items={items} />;
};

export default LiquidityStats;
